import style from "./loader.module.css"

export default function Loader() {
    return (
        <div className={style.center}>
            <span className={style.span} />
            <span className={style.span} />
            <span className={style.span} />
            <span className={style.span} />
        </div>
    )
}
